var mp = mp || {};


// Slider - Products
//-----------------------------------------------------------------
mp.sliderProducts = function() {
    var $slider = $('.products__slider .slider');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}


// Slider - Product Gallery
//-----------------------------------------------------------------
mp.sliderProductsGallery = function() {
    var $slider = $('.products__gallery .slider');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        arrows: false,
        dots: true,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    });
}



// Slider - Cars
//-----------------------------------------------------------------
mp.sliderCars = function() {
    var $slider = $('.cars__slider .slider');
    var $slider_nav = $('.cars__slider .slider-nav');

    if (!$slider.length) {
        return;
    }


    $slick = $slider.slick({
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
        dots: true,
        speed: 800,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
        appendArrows: $slider_nav,
        appendDots: $slider_nav,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}





$(document).ready(function (){
    mp.sliderProducts();
    mp.sliderProductsGallery();
});